import { countryCodes } from "~~/i18n";

export const CONSENT_MANAGER_VENDOR = {
  YOUTUBE: 's30',
} as const;

export const CONSENT_MANAGER_PURPOSE = {
  ESSENTIAL: 'c1',
  MEASUREMENT: 'c54',
} as const;

export const NEWSLETTER_OPTIONAL_COUNTRIES = [];
export const REVIEW_CONSENT_COUNTRIES = [countryCodes.CZ];
